import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/tokens.css' // token Design System KLH/BPLH v2.1
import './index.css'
import { NextUIProvider } from '@nextui-org/react'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { RouterProvider } from 'react-router-dom'
import router from './services/routes'
import { SWRConfig } from 'swr'
import muiTheme from './theme/muiTheme'
import './theme/highchartsTheme' // palet & gaya grafik Highcharts global

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
        <SWRConfig value={{ revalidateOnReconnect: false, revalidateOnMount: true, revalidateOnFocus: false }}>
            <NextUIProvider locale='en-GB'>
                {/* Tema MUI menyelaraskan DataGrid & date picker dengan palet KLH/BPLH */}
                <MuiThemeProvider theme={muiTheme}>
                    <RouterProvider router={router} />
                </MuiThemeProvider>
            </NextUIProvider>
        </SWRConfig>
);
